// Facebook posts data - มะระขี้นก (Bitter Melon) Cluster activities
export const fbPostsData = [
  {
    id: 1,
    title: 'จัดอบรมการทำตลาดออนไลน์ คลอส "ทำ TikTok ปังตังค์ไหลมา" โดยวิทยากรคิวทอง ครูดา #Wonderdar ณ กลุ่มบ้านเหม้า สุวรรณภูมิ และกลุ่มอารยะฟาร์ม เสลภูมิ จังหวัดร้อยเอ็ด',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02askpebjQ8c6eLiNkVgUQbcUEBc8YsBZStrVTbeHfHHxGYDs2Dt7csnNKNM7NQATel',
    category: 'อบรม',
  },
  {
    id: 2,
    title: 'ร่วมงาน SIE พลังภาคีเครือข่ายคลัสเตอร์ #บพท. #มะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02xAvUAmnRzUcckWpks1Ka9TwvhjYBVYY7ddPaHy99GFUoj1jniJ5n3WtJ1aASoddfl',
    category: 'กิจกรรม',
  },
  {
    id: 3,
    title: 'เสวนากลยุทธ์ธุรกิจชุมชนร่วม Cluster ถ่ายทำสกู๊ปข่าว cluster มะระขี้นก #บพท.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02Korgt5ywA5Lt594Y7sw1pmxUcznpTTsHBaXufiaRGro3RKmL8vBtyR67doutXXQFl',
    category: 'เสวนา',
  },
  {
    id: 4,
    title: 'เล่าเรื่องของมะระขี้นก และข้าวทุ่งกุลาร้องไห้ กรอบงาน Cluster SIE มะระขี้นก #บพท. ในงาน อว.แฟร์ – มหกรรมวิทย์ ปี 68',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02LAAr5nN1qPmS8dk6ZrBQyxTGLgDbYqJhWG5s43aedeZMwYzdz4b4vddqWmdLRCrQl',
    category: 'งานแสดง',
  },
  {
    id: 5,
    title: 'เสนอขายงานกับผู้แทนบริษัท Tops และ Wisco',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02sRvzGTMvMf7HMDMYPRfE8jTUxTDDCMBSso8zY9roMvUMGbRpa1yi1uRZq2GZpEEFl',
    category: 'ธุรกิจ',
  },
  {
    id: 6,
    title: 'พามะระขี้นก ข้าวทุ่งกุลาร้องไห้ และจิ้งหรีดพิมายร่วมงาน Scale up 2025',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02tCbfqM3k4RakULwTt7UxsQ1va3vv3LBR7iMmF4aeWiqbBapBtR4PBYeGwHtGsTJRl',
    category: 'งานแสดง',
  },
  {
    id: 7,
    title: 'น้ำนมข้าวผสมมะระขี้นก ของดีที่อยากบอกต่อ Mega Halal 2025 #บพท. #clusterมะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid09FJJCYaDNBiBt9YPqVeqPx3uZ28LBbYSj9YVb7ZE5m2NermvyzH21CEiVwXYxjUQl',
    category: 'ผลิตภัณฑ์',
  },
  {
    id: 8,
    title: 'Mega Halal 2025 #มะระขี้นก #บพท.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02kw3iD3mgZ5rFU4Jb6evxmCVpyHgz8WXRDvkpaZ1WSo61xB4CT1Kq1LHM25Pwrkzbl',
    category: 'งานแสดง',
  },
  {
    id: 9,
    title: 'ถ้าเราทำแบบเดิมผลลัพธ์ที่ได้ก็จะเหมือนเดิม เราต้องหาโอกาสทำสิ่งใหม่ๆ #มหกรรมสมุนไพรแห่งชาติ #มะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02ifn25Saaeqip8dHkn69bZXWjBNWM9fzcxsAXq9AnB2nLgw79sAqrFzVUeEMC8YKvl',
    category: 'งานแสดง',
  },
  {
    id: 10,
    title: 'พามะระขี้นกและข้าวทุ่งกุลาร้องไห้ เข้าร่วมงานมหกรรมสมุนไพรแห่งชาติ Thailand Herbal Expo 2025 ณ อิมแพ็คอารีน่า เมืองทองธานี',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0wnD21qhUKcRut2Xebekr1pnTqVk86NPNhfY77C3HfSFuDFxoySU4qxUbdNEhBxFAl',
    category: 'งานแสดง',
  },
  {
    id: 11,
    title: 'ลงทุนกับบรรจุภัณฑ์ สร้างมูลค่าเพิ่มให้ผลิตภัณฑ์ #น้ำนมข้าวผสมมะระขี้นก #คุกกี้ข้าวหอมมะลิผสมมะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02VNKMP2miVLiRe3Q86hGvKdZvGFoaEteGx4AhPJjKZZVuMBx2KbCJeYbgAVq7v3CKl',
    category: 'ผลิตภัณฑ์',
  },
  {
    id: 12,
    title: 'มาขายของ Cluster มะระขี้นก บุกตลาดฮาลาล ปัตตานี #น้ำนมข้าวหอมมะลิผสมมะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02gBWZPiaJGztJqNx759JQaFPdiLqyrPb8ZgxejvWxcSvBcvL1z7kFH1gFvot8zuerl',
    category: 'การตลาด',
  },
  {
    id: 13,
    title: 'Test run ผลิตภัณฑ์น้ำนมข้าวผสมมะระขี้นก ด้วยกระบวนการ "สเตอร์ไรด์" ด้วย Water retort technology ตามมาตรฐานฮาลาล GMP อย.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0KgYLGVg6YwDVQcMoZaELx7whnNajYboJyPh5iR5WJ2GXCgUMrm4iF2U4qjqRzV6Pl',
    category: 'การผลิต',
  },
  {
    id: 14,
    title: 'ขยายแปลงปลูกมะระขี้นกสู่กองพันทหารราบที่ 1 กรมทหารราบที่ 23 เชื่อมโครงการทหารพันธุ์ดี กับ Cluster มะระขี้นก #บพท.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0sQjNXSxZaQ9cA4yrtNeEH1tNerWPypGwUbkZCLfRTPeNsjeAyK2i5SDrjfktGKBVl',
    category: 'เกษตร',
  },
  {
    id: 15,
    title: 'ร่วมงาน Recharge Market 2025 โดย สสว. และสมาพันธ์เอสเอ็มอีไทย #มะระขี้นก #จิ้งหรีด #ข้าวหอมมะลิ',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0DB7QjJx5wgzZ7msGq3qJubZnZdBK4tf4hS4PssXe5GvVXffKLiYB7nwK2BAhV2f4l',
    category: 'งานแสดง',
  },
  {
    id: 16,
    title: 'ชีวิตคือการเดินทาง ลงพื้นที่วิสาหกิจชุมชนจังหวัดร้อยเอ็ด วางแผนการผลิตสินค้า ข้าว+มะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0EdRNpXxzopL2W8pTUxX5VHZ3Xi7cuXy1muuYHh8XzMYfVZLD1JKxLUYsC8NzmBqcl',
    category: 'ลงพื้นที่',
  },
  {
    id: 17,
    title: 'ทำงานยังไงให้ได้บุญ พามะระขี้นกบุกตลาดพระ',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0zVac57uowhe23fwx14dmY5BQ4qfadsNETWKz7tXePYQfQJwcek8U95BrXTzVTdjKl',
    category: 'การตลาด',
  },
  {
    id: 18,
    title: 'ขอบคุณทีมนักวิจัยที่เข้มแข็งทุกคน ว่าด้วยเรื่อง #มะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02VSaPJwCvhQTKaDkp33Pz3JuFmhkSEN1jXjg4LGNoUU6WqKcEAJPU5crBKz1tqaz1l',
    category: 'ทีมงาน',
  },
  {
    id: 19,
    title: 'ร่วมงาน Scale up 2025 สู่ตลาดใหญ่ ไฉไล และยั่งยืนกว่าเดิม จัดโดยสมาพันธ์เอสเอ็มอีไทย Tops และธนาคารออมสิน',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02NFPmZWUkV4sjcTqgp5iXJ7vD6dzNS1PcYRXnG83DXUrHTXx7wP7pE1yWEiPtQt4Hl',
    category: 'งานแสดง',
  },
  {
    id: 20,
    title: 'Business Matching นำเสนอผลิตภัณฑ์แปรรูปจากมะระขี้นกและข้าวพื้นเมือง กับบริษัทบิ๊กวันโอวัน จำกัด ร้อยเอ็ด',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid07PqTX7uyrABbozwxtmaZK9UTpkuruysdgYrB3Bjmey11V8x4Fr219bRdBVeUf6sjl',
    category: 'ธุรกิจ',
  },
  {
    id: 21,
    title: '23-25 พ.ค.2568 ร่วมงาน Business matching บริษัทราชาเฟอร์รี่ และรายงานความก้าวหน้าโครงการ Cluster #มะระขี้นก #บพท',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02RUubGiztLa8bvjZJouzwd7BWfqHMgpojGSweoJS5DFvRT5kFtn3bWk28vRRf6sYfl',
    category: 'ธุรกิจ',
  },
  {
    id: 22,
    title: 'ว่าด้วยเรื่องมะระขี้นก #บพท. เชื่อมโยงกลุ่มเกษตรกรผู้ผลิตและแปรรูปมะระขี้นก ร้อยเอ็ด โคราช ศึกษาดูงาน ณ วิสาหกิจชาววัง จังหวัดปราจีนบุรี',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid034FZagRToY8fsRo28QWBZHiWByP4NJGtRJBwVGeCqbXppBz9DNYMufXh9d1g6dG3il',
    category: 'ศึกษาดูงาน',
  },
  {
    id: 23,
    title: '12 พ.ค.68 เปิดเวทีปฏิญญาความร่วมมือการพัฒนาเครือข่ายธุรกิจชุมชนร่วม : คลัสเตอร์มะระขี้นก และผลิตภัณฑ์เชื่อมโยง #บพท.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0b2bx8EmJmHNLSEaXn7MNCciTTtTSNnptoYTUpGdSetDs3vSu6x92tv3cVmC8DCAol',
    category: 'เครือข่าย',
  },
  {
    id: 24,
    title: 'โปรเจคมะระขี้นกหมักคอมบูชา (Kombucha) ด้วยหัวเชื้อ SCOBY สายพันธุ์พิเศษ #มะระขี้นกลดเบาหวาน #อาหารเป็นยา',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02AvGyE4EpV9s68Z722xnCp8foypjNHqgvrjYPn6136jydcxeWv2ZqvMRbC47ifDbml',
    category: 'วิจัย',
  },
  {
    id: 25,
    title: 'Cluster มะระขี้นก #บพท. นำทัพเข้าหารือกับทางซินโครตรอน องค์การมหาชน ขับเคลื่อนงานมะระขี้นก วาระแห่งชาติ',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02EvZotNCYyC5zn7SuSDqETXPFUa7tBCTCDE9JsmbhNj8sc4wWTFgKLJaDfn5L2W7ql',
    category: 'เครือข่าย',
  },
  {
    id: 26,
    title: 'ว่าด้วยเรื่องเครือข่ายมะระขี้นก ร้อยเอ็ด',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0jB3e8ykLtaL2dgyfZjXdywmmUK7D9BRB6U2zUCfkcjXyFfhgvdBz2FxmjVDMrq4Rl',
    category: 'เครือข่าย',
  },
  {
    id: 27,
    title: 'ต้อนรับผู้ทรงฯ จาก #บพท และหัวหน้าโครงการ cluster มะระขี้นก ติดตามผลการดำเนินงาน และเยี่ยมชม "ครัวราชมงคลอีสาน"',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02KLZ7kBfBE6p9RQ6pEzk9fqZogdpiQ2CUmwbUFGn84X4NoB6MaHz3DPthcaa9qov8l',
    category: 'ติดตามผล',
  },
  {
    id: 28,
    title: 'Cluster มะระขี้นก เปเปอร์แรกคลอดแล้ว Pubmed Q3 #ฤทธิ์ต้านเชื้อก่อโรค',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02ZRzW39rG5Cd3TByizYsurmjnJMTGu8rmvoqJZfvyMSAsRATrVJvMRRcqs52APUybl',
    category: 'วิจัย',
  },
  {
    id: 29,
    title: 'ลงกลุ่มขึ้นงานแปรรูปข้าวและมะระขี้นก #ชาใบข้าวหอมมะลิ+มะระขี้นก #เกษตรวิสัย #สุวรรณภูมิ',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02JprDd4NUiCRu5m3efbn4xgVPN9sJZA2RVouVRs3DkHoWhjzWoC3R2MmXdt1Gwm8rl',
    category: 'การผลิต',
  },
  {
    id: 30,
    title: 'โปรเจคปลูกมะระขี้นก ด้วยการควบคุมแสงสีต่างๆ ระบบอิเล็กทรอนิกส์ทางการเกษตรแนวตั้ง ภายใต้ห้องควบคุมอัตโนมัติ',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0wadcsbLTkn5dpJR3eg95754HHkX64hFSC6sGZHrtrYZPqMsSo3sNs4j2PPWFJ6Ntl',
    category: 'เกษตร',
  },
  {
    id: 31,
    title: 'การผลิตมะระขี้นกผง ด้วยเทคโนโลยีทำแห้งแบบพ่นฝอย Spray drying technology',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02AjuDroYEHrszMqpLy9Tyyz7ssfyB9cXVE7CoCD7SY9iYHiiPwR5zi6ZUjn4tFcRPl',
    category: 'การผลิต',
  },
  {
    id: 32,
    title: 'ลงพื้นที่มะระขี้นก จังหวัดร้อยเอ็ด',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0C99wa3bpGZzw7VDrNb4umMSVpbyrjTUrXZqjAawL9FvnueUR1niEpStrjqWqo9Dyl',
    category: 'ลงพื้นที่',
  },
  {
    id: 33,
    title: 'รายงานความก้าวหน้าระยะ 4 เดือน Cluster มะระขี้นก #บพท',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0Q9UiLFnqZ3gzsDWbHVqTQhwQL9q6iefoZxrvH1kHeEBZrthTzcJFxChBguXgYBz5l',
    category: 'รายงาน',
  },
  {
    id: 34,
    title: 'ลงพื้นที่ปรึกษาหารือผู้เชี่ยวชาญ วิเคราะห์สารสำคัญในมะระขี้นก จากคณะเภสัชฯ มหาวิทยาลัยมหาสารคาม',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02TWXWYzrABtYoPLJrzsmBn3yGzkfeFyVR5CjWrghPnePcu9MomX7mvYCjNrPVLvZrl',
    category: 'วิจัย',
  },
  {
    id: 35,
    title: 'ร่วมแลกเปลี่ยนหารือโครงการ SIE และโครงการ Cluster มะระขี้นก #บพท ณ ทุ่งกุลาร้องไห้ มทร.อีสาน',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid023MFZnZqvHEfJ1cyaBxdgtV4L8btKrcrSWicgKAmwHyAeAwo7pMoixz6u2hL4jCBnl',
    category: 'เครือข่าย',
  },
  {
    id: 36,
    title: 'โครงการ SIE และ #clusterมะระขี้นก',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid02jvqccG8ua9jzb7RAexu7eu3CBdZEshLtyWoWbWbEfuBBbhFDwpirh6XmHPGiwcGBl',
    category: 'กิจกรรม',
  },
  {
    id: 37,
    title: '13-14 ก.ค. 67 อบรม Mini-ERP #cluster มะระขี้นก #SIE มทร.อีสาน #บพท.',
    url: 'https://www.facebook.com/apichai.sawisit/posts/pfbid0fRwH85LPHjsYkxfXF5iYLPcpxCVsFJDGaNWFP5KnXfCUmfBfgdpjbSKKwJj3EhL3l',
    category: 'อบรม',
  },
]

// Category config for styling
export const fbCategoryConfig = {
  'อบรม': { color: 'blue', icon: '🎓' },
  'กิจกรรม': { color: 'teal', icon: '🎯' },
  'เสวนา': { color: 'purple', icon: '🎤' },
  'งานแสดง': { color: 'orange', icon: '🏛️' },
  'ธุรกิจ': { color: 'emerald', icon: '💼' },
  'ผลิตภัณฑ์': { color: 'pink', icon: '📦' },
  'การตลาด': { color: 'red', icon: '🛒' },
  'ลงพื้นที่': { color: 'amber', icon: '📍' },
  'ทีมงาน': { color: 'cyan', icon: '👥' },
  'เครือข่าย': { color: 'indigo', icon: '🤝' },
  'วิจัย': { color: 'violet', icon: '🔬' },
  'การผลิต': { color: 'lime', icon: '🏭' },
  'เกษตร': { color: 'green', icon: '🌱' },
  'ติดตามผล': { color: 'sky', icon: '📋' },
  'รายงาน': { color: 'slate', icon: '📊' },
  'ศึกษาดูงาน': { color: 'fuchsia', icon: '🔍' },
}
